import * as React from 'react'
import autobind from 'autobind-decorator'
import {connect} from 'redux-scaffolding-ts'
import {withTranslation, WithTranslation} from 'react-i18next'
import {Button, Icon} from 'antd'
import {ProjectsStore} from 'src/stores/projects-store'
import {ItemReference, QueryResult} from 'src/core/stores/dataStore'
import NewProjectView from 'src/pages/admin/projects/project-new';
import NewProjectViewUser from 'src/pages/admin/projects/project-new-user';
import SelectionInput from '../core/ui/form/selectionInput'

interface ProjectEditorProps extends WithTranslation {
    companyId: string,
    disabled?: boolean,
    value?: number,
    onChange?: (value: number) => void,
    placeholder?: string,
    nullable?: boolean,
    minWidth?: number,
    onCallback?: (id: string | undefined) => void,
    firstTaskOptional: boolean,
    companyAllowCir: boolean,
    companyAllowCii: boolean,
    isOnlyUser?: boolean
    closeAllModal?: () => void
}

interface ProjectEditorState {
    projectId: string | number | undefined,
    addNewProject: boolean
}

@connect(['projects', ProjectsStore])
class ProjectEditor extends React.Component<ProjectEditorProps, ProjectEditorState> {

    private get projectsStore() {
        return (this.props as any).projects as ProjectsStore;
    }

    constructor(props: ProjectEditorProps) {
        super(props);
        this.state = {
            projectId: props.value,
            addNewProject: false,
        }
        this.projectsStore.changeUrl(this.props.companyId)
    }

    static getDerivedStateFromProps(nextProps: ProjectEditorProps, prevState: ProjectEditorState) {
        if (nextProps.value !== prevState.projectId) {
            return { projectTaskId: nextProps.value };
        }
        else return null;
    }

    @autobind
    private async getProjects(searchQuery: string): Promise<QueryResult<ItemReference>> {
        var result = await this.projectsStore.getAllAsync({
            searchQuery: searchQuery,
            skip: 0,
            take: 100,
            orderBy: [{ field: 'title', direction: "Ascending", useProfile: true }]
        }, undefined, this.props.companyId) || { count: 0, items: [] };

        return {
            count: result.count,
            items: result.items.map(o => ({
                id: `${o.id}`,
                title: `${o.title}`
            } as ItemReference))
        } as QueryResult<ItemReference>
    }

    public render() {
        const { t } = this.props;

        return (<div>
            <SelectionInput
                content={(o) =>
                    <div>
                        <Icon type="project" />
                        <span>&nbsp;{o ? o.title : ""}</span>
                    </div>}
                searchable
                disabled={this.props.disabled}
                minWidth={this.props.minWidth}
                width={'48.5%'as any}
                nullable={this.props.nullable}
                placeholder={this.props.placeholder}
                query={this.getProjects}
                value={this.state.projectId as any}
                showFooter
                onChange={(item: any) => { if (this.props.onChange) { this.props.onChange(item && item.id ? item.id : item as any || undefined) }}}
            />

            <a onClick={() => this.setState({ addNewProject: true })}><Button style={{ padding: "0px 8px", marginLeft:"10px" }}><Icon type="plus" /></Button> {t("New project")}</a>

            {this.state.addNewProject && !this.props.isOnlyUser &&
                <NewProjectView
                companyAllowCir={this.props.companyAllowCir}
                companyAllowCii={this.props.companyAllowCii}
                firstTaskOptional={this.props.firstTaskOptional}
                    companyId={this.props.companyId}
                    onClose={() => {
                        this.setState({addNewProject: false})
                        this.props.closeAllModal && this.props.closeAllModal()
                    } }
                    onOk={(pid) => {
                        this.setState({ projectId: pid })
                        if (this.props.onCallback) this.props.onCallback(pid)
                    }}
                />}


            {this.state.addNewProject && this.props.isOnlyUser &&
                <NewProjectViewUser
                    companyAllowCir={this.props.companyAllowCir}
                    companyAllowCii={this.props.companyAllowCii}
                    firstTaskOptional={this.props.firstTaskOptional}
                    companyId={this.props.companyId}
                    isOnlyUser={this.props.isOnlyUser}
                    onClose={() => {
                        this.setState({addNewProject: false})
                        this.props.closeAllModal && this.props.closeAllModal()
                    }}
                    onOk={(pid) => {
                        this.setState({ projectId: pid })
                        if (this.props.onCallback) this.props.onCallback(pid)
                    }}
                />}
        </div>
        );
    }
}

export default withTranslation()(ProjectEditor);